import React from 'react';
import ExcelLogo from "../assets/excel-logo.png";

export default function ExcelIcon(props) {

	return (

            <img src={ExcelLogo} height="25px" { ...props}/>
	)
}